import React from "react";
import { ArrowRight, ArrowLeft, ShieldCheck, Zap } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

const BRANDS = [
  {
    key: "tesla",
    name: "Tesla",
    tagline: "Fleet API · read-only · full battery intelligence",
    href: `${API}/api/tesla/authorize?return_to=/app`,
    accent: "#00E5FF",
    testid: "connect-tesla-btn",
  },
  {
    key: "ford",
    name: "Ford",
    tagline: "FordConnect · early access — connection first, insights rolling out",
    href: `${API}/api/oauth/ford/start`,
    accent: "#7DB3FF",
    testid: "connect-ford-btn",
  },
  {
    key: "volvo",
    name: "Volvo / Polestar",
    tagline: "Volvo ID · early access — battery + charging via Volvo Cars API",
    href: `${API}/api/oauth/volvo/start`,
    accent: "#9CC7E8",
    testid: "connect-volvo-btn",
  },
];

export default function ConnectPage() {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center px-5 py-12">
      <div className="w-full max-w-md" data-testid="connect-page">
        <a
          href="/"
          className="inline-flex items-center gap-1.5 text-[11px] font-mono uppercase tracking-wider text-zinc-500 hover:text-white transition-colors mb-8"
          data-testid="connect-back-link"
        >
          <ArrowLeft className="w-3.5 h-3.5" strokeWidth={2.2} /> Back
        </a>

        <div className="mb-8">
          <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-zinc-500 mb-2">
            Sign in
          </div>
          <h1 className="text-2xl sm:text-3xl font-semibold leading-tight">
            Choose your vehicle
          </h1>
          <p className="text-sm text-zinc-400 mt-2 leading-relaxed">
            EVIQ connects through your manufacturer's official API —
            read-only, encrypted, revocable anytime.
          </p>
        </div>

        <div className="space-y-3">
          {BRANDS.map((b) => (
            <a
              key={b.key}
              href={b.href}
              data-testid={b.testid}
              className="group flex items-center gap-4 rounded-2xl border p-4 transition-colors"
              style={{ borderColor: `${b.accent}40`, background: `${b.accent}0D` }}
            >
              <div
                className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0"
                style={{ background: `${b.accent}1A`, border: `1px solid ${b.accent}55` }}
              >
                <Zap className="w-5 h-5" style={{ color: b.accent }} strokeWidth={2.2} />
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-base font-semibold" style={{ color: b.accent }}>
                  {b.name}
                </div>
                <div className="text-[11px] text-zinc-400 leading-snug mt-0.5">
                  {b.tagline}
                </div>
              </div>
              <ArrowRight
                className="w-4 h-4 shrink-0 text-zinc-500 group-hover:translate-x-0.5 transition-transform"
                strokeWidth={2.4}
              />
            </a>
          ))}
        </div>

        <div className="mt-8 flex items-center justify-center gap-6 text-[10px] font-mono uppercase tracking-[0.12em] text-zinc-600">
          <span className="inline-flex items-center gap-1.5">
            <ShieldCheck className="w-3 h-3" strokeWidth={2} /> Read-only
          </span>
          <span className="inline-flex items-center gap-1.5">
            <ShieldCheck className="w-3 h-3" strokeWidth={2} /> AES-256
          </span>
          <span className="inline-flex items-center gap-1.5">
            <ShieldCheck className="w-3 h-3" strokeWidth={2} /> Revocable
          </span>
        </div>
      </div>
    </div>
  );
}
